<ng-container [ngSwitch]="data.status">
  <ng-container *ngSwitchCase="'IN_PROGRESS'"> <span class="status-dot">Ongoing</span></ng-container>
  <ng-container *ngSwitchCase="'DONE'">
    <span>{{ data.text }}</span>
  </ng-container>
</ng-container>
